<template>
  <v-dialog max-width="550px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Touch Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="6" class="pt-5">
            <r-item-touch-action :model.sync="model.longTouchAction" label="Long Touch Action"/>
          </v-col>
          <v-col cols="12" sm="6" md="6" class="pt-5">
            <v-checkbox v-model="model.longTouchReminder" label="Long touch reminder" hide-details :disabled="!model || model.longTouchAction.id === 0" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import {ViewRules} from "@/common/ViewRules";
import {ItemTouchConfig} from "@/modules/redactor/models/item/touch/ItemTouchConfig";
import RItemTouchAction from "@/modules/redactor/views/item/touch/r-item-touch-action.vue";


export default {
  name: "r-item-touch-config",
  components: {RItemTouchAction},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemTouchConfig(),
    rules: ViewRules.READONLY,
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemTouchConfig();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>